import { REAL_ESTATE_TAXES_SALT_CAP } from '../constants/loans';
import { OccupancyUse } from '../types/reports';
import { OCCUPANCY_USE } from '../components/Pages/Reports/constants';
import { formatAmount } from './formatAmount';

export const calculateRealEstateTaxes = (propertyTaxes: number, occupancyUse: OccupancyUse): number => {

   if (occupancyUse === OCCUPANCY_USE.PRIMARY_RESIDENCE) {
     return propertyTaxes * 12 > REAL_ESTATE_TAXES_SALT_CAP ?
       REAL_ESTATE_TAXES_SALT_CAP : parseFloat(formatAmount(propertyTaxes * 12));
   }


  return parseFloat(formatAmount(propertyTaxes * 12));
}
